<template>
  <v-dialog
    :value="loading"
    persistent
    width="300"
  >
    <v-container class="pa-12 white text-center">
      <LoadingSpinner />
      Loading...
    </v-container>
  </v-dialog>
</template>

<script>
export default {
  props: { loading: { type: Boolean, default: false } }
};
</script>
